
export default {
  name: 'Loading',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
